var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 228,
    viewBox: "0 0 305 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 114,
    r: 114,
    fill: "#223238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1641_42457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 39C4 34.5817 7.58172 31 12 31H293C297.418 31 301 34.5817 301 39V190C301 194.418 297.418 198 293 198H12C7.58173 198 4 194.418 4 190V39Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 50C67 47.2386 69.2386 45 72 45H95C97.7614 45 100 47.2386 100 50C100 52.7614 97.7614 55 95 55H72C69.2386 55 67 52.7614 67 50Z",
    fill: "#006F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 50C148 47.2386 150.239 45 153 45H174C176.761 45 179 47.2386 179 50C179 52.7614 176.761 55 174 55H153C150.239 55 148 52.7614 148 50Z",
    fill: "#006F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 50C226 47.2386 228.239 45 231 45H252C254.761 45 257 47.2386 257 50C257 52.7614 254.761 55 252 55H231C228.239 55 226 52.7614 226 50Z",
    fill: "#006F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 68C10 63.5817 13.5817 60 18 60H287C291.418 60 295 63.5817 295 68V93C295 97.4183 291.418 101 287 101H18C13.5817 101 10 97.4183 10 93V68Z",
    fill: "#273337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 149C10 144.582 13.5817 141 18 141H287C291.418 141 295 144.582 295 149V174C295 178.418 291.418 182 287 182H18C13.5817 182 10 178.418 10 174V149Z",
    fill: "#273337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 81C66 78.2386 68.2386 76 71 76H110C112.761 76 115 78.2386 115 81C115 83.7614 112.761 86 110 86H71C68.2386 86 66 83.7614 66 81Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 162C66 159.239 68.2386 157 71 157H110C112.761 157 115 159.239 115 162C115 164.761 112.761 167 110 167H71C68.2386 167 66 164.761 66 162Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 81C118 78.2386 120.239 76 123 76C125.761 76 128 78.2386 128 81C128 83.7614 125.761 86 123 86C120.239 86 118 83.7614 118 81Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 162C118 159.239 120.239 157 123 157C125.761 157 128 159.239 128 162C128 164.761 125.761 167 123 167C120.239 167 118 164.761 118 162Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 121C65 118.239 67.2386 116 70 116H102C104.761 116 107 118.239 107 121C107 123.761 104.761 126 102 126H70C67.2386 126 65 123.761 65 121Z",
    fill: "#59717B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 81C147 78.2386 149.239 76 152 76H196C198.761 76 201 78.2386 201 81C201 83.7614 198.761 86 196 86H152C149.239 86 147 83.7614 147 81Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 162C147 159.239 149.239 157 152 157H196C198.761 157 201 159.239 201 162C201 164.761 198.761 167 196 167H152C149.239 167 147 164.761 147 162Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 121C146 118.239 148.239 116 151 116H195C197.761 116 200 118.239 200 121C200 123.761 197.761 126 195 126H151C148.239 126 146 123.761 146 121Z",
    fill: "#59717B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 81C225 78.2386 227.239 76 230 76H274C276.761 76 279 78.2386 279 81C279 83.7614 276.761 86 274 86H230C227.239 86 225 83.7614 225 81Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 162C225 159.239 227.239 157 230 157H274C276.761 157 279 159.239 279 162C279 164.761 276.761 167 274 167H230C227.239 167 225 164.761 225 162Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 121C224 118.239 226.239 116 229 116H273C275.761 116 278 118.239 278 121C278 123.761 275.761 126 273 126H229C226.239 126 224 123.761 224 121Z",
    fill: "#59717B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 81C51 89.2843 44.2843 96 36 96C27.7157 96 21 89.2843 21 81C21 72.7157 27.7157 66 36 66C44.2843 66 51 72.7157 51 81Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 162C51 170.284 44.2843 177 36 177C27.7157 177 21 170.284 21 162C21 153.716 27.7157 147 36 147C44.2843 147 51 153.716 51 162Z",
    fill: "#3B5965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 122C51 130.284 44.2843 137 36 137C27.7157 137 21 130.284 21 122C21 113.716 27.7157 107 36 107C44.2843 107 51 113.716 51 122Z",
    fill: "#59717B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1641_42457",
    x: 0,
    y: 31,
    width: 305,
    height: 175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1641_42457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1641_42457",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataDarkMode);
export default __webpack_public_path__ + "static/media/NoDataDarkMode.988a19d31dcaf7a2008d15bfcb72ddb0.svg";
export { ForwardRef as ReactComponent };